import React, { Component, createRef } from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { Row, Col, Container, Modal, Button, Nav } from 'react-bootstrap'
import isEmpty from 'lodash/isEmpty'
import {
  IS_BROWSER,
  getLocalStorage,
  setLocalStorage,
  enablePdpRedesign,
  i18nTranslate,
  trackEnhancedCartEvent,
  getLiveEventStatus,
  getWebAvailableChannel,
  isExpressCheckout,
  checkEnableButton,
  getLocaleCodeFromUrl,
  showCrossSellProducts,
  scrollState,
} from 'src/utils'
import {
  ProductImageWithFavorites,
  ProductDetail,
  ProductDetailSection,
  ProductContext,
  ProductComponent,
  RecommendedProducts,
} from 'src/views/components'
import { PDPContext } from 'src/views/components/BaseProductComponent'
import { productState } from 'src/views/components/BaseProductComponent/ProductState'
import {
  ProductShipping,
  ProductRefundPolicy,
  ProductIngredients,
  ProductInfobar,
  ProductBenefitsandFeatures,
  ProductProvenResults,
  ProductHowtoUseit,
  Productfaq,
  ProductDetailsDropdown,
  ProductDisclaimers,
  ProductSustainability,
  ProductResources,
  CrossSellUpSell,
  // ProductDisclaimerWarnings,
} from 'src/views/components/ProductComponents'
import {
  storeContainer,
  nuskinSubscriptionContainer,
  cartContainer,
  customerContainer,
  promotionContainer,
  checkoutContainer,
  nlxxConfigContainer,
} from 'src/models'
import { productDeps } from 'src/deps'
import {
  APPConfig,
  deleteFromLocalStorage,
  getBuyNowInPDP,
} from 'config/appConfig'
import { Link } from 'react-router-dom'
import NotFound from '../NotFound'
import './styles.scss'
import FrequentlyBoughtTogether from 'src/views/components/FrequentlyBoughtTogether'
import { RelatedProduct } from 'src/views/components/ProductComponents/RelatedProduct'
import { isEquinoxMysite, isEquinoxPOSite } from 'src/utils/mySiteUtils'

@observer
class ExpressPDP extends ProductComponent {
  nameSpace = 'ssr-resource'
  @observable isSubscriptionProduct = false
  @observable showCustomerModal = true
  enableLiveEvent = getLiveEventStatus()
  isEventRegisteredUser = ''
  timeoutInstance = ''
  constructor(props, context) {
    super(props, context)
    if (typeof window !== 'undefined') {
      console.log('Loop [ExpressPDP] CONSTRUCTOR', {
        key: props.key || '',
        path: props?.location?.pathname || '',
        search: props?.location?.search || '',
        match: props?.match || {},
        stack: new Error().stack || '',
      })
    }
    this.barRef = createRef()
    this.state = { isStuck: false }
    this.updateHeaderHeight = this.updateHeaderHeight.bind(this)
  }

  updateHeaderHeight = () => {
    if (typeof window === 'undefined') {
      return
    }
    if (!isEquinoxMysite() && !isEquinoxPOSite()) {
      return
    }

    const nuHeader =
      document.querySelector('.nu-header-container') ||
      document.querySelector('.header-mfe-container')
    let totalHeaderHeight = 0

    if (nuHeader) {
      const height = nuHeader.offsetHeight
      totalHeaderHeight = height
    } else {
      totalHeaderHeight = 300
    }
    const screenWidth = window.innerWidth
    let adjustedHeaderHeight = totalHeaderHeight

    if (screenWidth > 1024) {
      adjustedHeaderHeight = totalHeaderHeight - 38
    }
    document.documentElement.style.setProperty(
      '--product-details-bar-top',
      `${adjustedHeaderHeight}px`
    )
  }

  isInvalidHomeMarket() {
    const homeCountry = customerContainer?.getUserHomeCountry() || ''
    const pageURl = window.location.href || ''
    const accountType = getLocalStorage('accountType') || ''
    const curLocale = getLocaleCodeFromUrl({
      url: pageURl,
      at: 'pathParam',
      defaultLocale: APPConfig.getAppConfig().defaultLocale || 'en_US',
      isReverseType: true,
    })
    const [language, activeCountryCode] = curLocale.includes('_')
      ? curLocale.split('_')
      : curLocale.split('-')
    const isNativeApp = window?.isNativeApp || false
    return (
      homeCountry !== activeCountryCode &&
      accountType === 'Retail Customer' &&
      isNativeApp === false &&
      homeCountry !== ''
    )
  }

  async componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    this.handleScroll()

    // Load NLXX configuration for product restriction checks
    nlxxConfigContainer.loadNLXXConfig()

    // Set header height CSS variable
    if (IS_BROWSER) {
      const header =
        document.querySelector('.nu-header-container') ||
        document.querySelector('.header-mfe-container')
      if (!header) return

      const updateHeaderHeight = () => {
        const rect = header.getBoundingClientRect()
        const visibleBottom = Math.max(rect.bottom, 0)
        document.documentElement.style.setProperty(
          '--header-height',
          `${visibleBottom}px`
        )
      }

      updateHeaderHeight()
      this._headerScrollHandler = updateHeaderHeight
      window.addEventListener('scroll', this._headerScrollHandler, {
        passive: true,
      })
    }

    const homeMarket = customerContainer?.getUserHomeCountry() || ''
    await cartContainer.viewCart()
    if (!getLocalStorage('isExpressPDPLogin')) {
      if (
        !cartContainer?.cartResponse?.properties?.klarnaSessionVerifierKey &&
        cartContainer.cartResponse?.items?.length &&
        cartContainer.cartResponse?.cartType === 'EXPRESS'
      ) {
        await cartContainer.deleteCartItem(
          '',
          '',
          '',
          false,
          false,
          null,
          null,
          null,
          false
        )
      }
    } else if (
      customerContainer?.isRegisterUser &&
      getLocalStorage('isExpressPDPLogin')
    ) {
      checkoutContainer.renderExpressPDPCart =
        checkoutContainer.showExpressCheckoutModalBody = true
      if (this.isInvalidHomeMarket()) {
        checkoutContainer.showExpressCheckoutDrawer = false
      } else {
        checkoutContainer.showExpressCheckoutDrawer = true
        this.timeoutInstance = setTimeout(() => {
          const desiredProductId = this.props?.match?.params?.productId || ''
          const product = cartContainer?.cartResponse?.items?.find(
            item =>
              item?.properties?.slug === desiredProductId ||
              item?.skus?.find(sku => sku?.productId === desiredProductId)
          )
          productState.productCount = product?.quantity || 1
          productState.handleQuantityChangePromotion(
            productState.product,
            productState.productCount
          )
        }, 1000)
      }
      deleteFromLocalStorage('isExpressPDPLogin')
    }
  }

  async componentWillUnmount() {
    clearTimeout(this.timeoutInstance)
    setLocalStorage('isExpressCart', false)
    await cartContainer.viewCart()
    if (!this.isSubscriptionProduct) {
      productState.resetValues()
    }
    window.removeEventListener('scroll', this.handleScroll)
    if (this._headerScrollHandler) {
      window.removeEventListener('scroll', this._headerScrollHandler)
    }
  }

  handleScroll = () => {
    if (!this.barRef.current) return
    const { top } = this.barRef.current.getBoundingClientRect()
    const shouldBeStuck = top <= 0
    if (shouldBeStuck !== this.state.isStuck) {
      this.setState({ isStuck: shouldBeStuck })
    }

    if (!this._scrollUpdateTimeout) {
      this._scrollUpdateTimeout = setTimeout(() => {
        this.updateHeaderHeight()
        this._scrollUpdateTimeout = null
      }, 100)
    }
  }

  componentDidUpdate(prevProps) {
    // Calls get product only if pathname is changed
    // Query param change is ignored
    const isPathChanged =
      JSON.stringify(prevProps?.location?.pathname) !==
      JSON.stringify(this.props?.location?.pathname)

    /**
     * isVariantChangedFromMiniCart is a edge case
     * https://nuskin.atlassian.net/browse/CX16-10051
     *
     * consider we are in pdp which has variants
     * and we are in mini cart and we click on the same pdp url with different variant
     * if variant is changed from mini cart, then we need to call getProduct
     *
     * this is a temporary fix, we are unable to handle variant click when url is changed from mini cart
     * hence making the API for the Edge case
     */
    const isVariantChangedFromMiniCart =
      JSON.stringify(prevProps?.location?.search) !==
        JSON.stringify(this.props?.location?.search) &&
      cartContainer.isCartVisible

    if (isPathChanged || isVariantChangedFromMiniCart) {
      promotionContainer.resetV2PromoResponse()
      productState.getProduct(this.props)
    }
  }

  handleClose() {
    this.showCustomerModal = false
  }

  isJsonObject = strData => {
    try {
      JSON.parse(strData)
    } catch (e) {
      return false
    }
    return true
  }
  checkEventRegisteredUser() {
    const profileResponse = customerContainer?.profileResponse
    const accountProperties = profileResponse?.accounts?.properties || []
    const userProperty = accountProperties?.filter(
      property => property?.attributeId === 'registeredEvent'
    )
    return userProperty?.[0]?.value || 'false'
  }

  // TODO : Reuse this method from Product.tsx
  renderProductView = (
    productResponse = {},
    product = {},
    productCount = 1,
    inventory = {},
    subscribeAndSave = 0
  ) => {
    this.isEventRegisteredUser = this.checkEventRegisteredUser()
    if (IS_BROWSER) {
      const productStatus = document.getElementById('qa-product-availability')
      const text = productStatus?.textContent
      productStatus?.setAttribute('role', 'alert')
      productStatus?.setAttribute('aria-label', text)
    }
    //subscription product redirection
    if (!getBuyNowInPDP()) {
      const isBundleOrKit =
        product?.type === 'bundle' || product?.type === 'kit'
      const availableChannelsList = this.isBundleOrKit
        ? product?.properties?.availableChannels || ''
        : product?.availableChannels || ''
      const shouldShowOneTimeButton = checkEnableButton(
        availableChannelsList,
        getWebAvailableChannel()
      )
      const shouldShowSubscriptionButton = checkEnableButton(
        availableChannelsList,
        'subscription'
      )
      if (
        isExpressCheckout() &&
        !shouldShowOneTimeButton &&
        shouldShowSubscriptionButton
      ) {
        this.isSubscriptionProduct = true
        this.props?.history?.replace(`/product/${product.properties.slug}`)
        return <></>
      }
      this.isSubscriptionProduct = false
    }
    // @##pdp_scancard
    const scanCount = productResponse?.product?.properties?.scanQualifiedCount
    const enableNewPDPStyle =
      APPConfig?.getAppConfig()?.enableNewPDPStyle === 'true'
    if (productResponse?.product) {
      const {
        isCollection = false,
        isBundle = false,
        categoryId = '',
      } = product
      const activeStoreResponse = storeContainer.activeStoreResponse
      let currentAccountType = getLocalStorage('accountType')
      let customerConfigs = []
      let customerName = ''
      let customerConfigObj = ''
      activeStoreResponse?.properties?.find(data => {
        try {
          if (data.name === 'customerTypeAssociationConfig') {
            customerConfigs = JSON.parse(data?.value || '{}')
          }
        } catch (e) {
          console.log('JSON.parse() >>> error ', e)
        }
      })

      const customerAssociationConfig = activeStoreResponse?.properties?.filter(
        data => data.name === 'customerTypeAssociationConfig'
      )
      try {
        if (customerAssociationConfig) {
          customerConfigs = JSON.parse(customerAssociationConfig.value)
        }
      } catch (e) {}
      customerConfigObj = !isEmpty(customerConfigs)
        ? customerConfigs?.config[currentAccountType]
        : {}

      customerName = customerConfigObj?.hasOwnProperty('name')
        ? customerConfigObj?.name?.toLowerCase()
        : 'NotFound'
      let allowedCustomerType = product.customerTypes?.toLowerCase()
      const { location = '', history = '', match = '' } = this.props
      const isProductEligible =
        currentAccountType?.includes('Brand Affiliate') ||
        currentAccountType == null ||
        allowedCustomerType?.includes(customerName) ||
        customerName === 'NotFound'

      if (this.enableLiveEvent === 'true') {
        const productData = {
          band: product?.brand,
          categoryId: product?.categoryId,
          currency: product?.currency,
          productName: product?.name,
          quantity: '',
          skuId: product?.skuId,
          totalPrice: product?.totalValue?.priceAfterDiscount,
          variantLabel: product?.variantLabel,
        }
        if (
          customerContainer.isRegisterUser &&
          this.isEventRegisteredUser === 'false'
        ) {
          trackEnhancedCartEvent({
            type: 'view_not_register_alert',
            item: productData,
            price: product?.totalValue?.priceAfterDiscount,
          })
        }
        trackEnhancedCartEvent({
          type: 'view_item',
          item: productData,
          price: product?.totalValue?.priceAfterDiscount,
        })

        // view_promotion event is disabled as July Live Event is not having promotions
        // if (product?.promotion?.length > 0) {
        //   trackProductClickEvent({
        //     type: 'view_promotion',
        //     action: { list: 'Search Results' },
        //     categoryId: product?.categoryId,
        //     product,
        //     promotionClass: product?.promotion?.[0]?.promotionClass,
        //     offerId: product?.promotion?.[0]?.offerId,
        //     promotion: true,
        //   })
        // }
      }

      const isProductDetailsAvailable = () => {
        const safeParseProductDetails =
          safeParse(productState?.product?.productDetails) || {}
        const proDetails =
          safeParseProductDetails.description?.length > 0 ||
          safeParseProductDetails.highlights?.length > 0 ||
          safeParseProductDetails.importer?.length > 0 ||
          safeParseProductDetails.includedItems?.length > 0 ||
          safeParseProductDetails.originCountry?.length > 0 ||
          safeParseProductDetails.warnings?.length > 0 ||
          safeParse(productState?.product?.productDetailsDescription)?.length >
            0
        return proDetails
      }

      // Function to determine the first available tab
      const getDefaultActiveKey = isDefault => {
        const availableTabs = [
          {
            condition: productState?.product?.features,
            key: '#why',
          },
          {
            condition: isProductDetailsAvailable(),
            key: '#details',
          },
          {
            condition: safeParse(
              productState?.product?.benefits
            )?.benefits?.trim(),
            key: '#benefits',
          },
          {
            condition:
              safeParse(productState?.product?.usage).steps?.length > 0 ||
              safeParse(productState?.product?.usage).recommendations?.length >
                0 ||
              safeParse(productState?.product?.usage).additionalText?.length >
                0,
            key: '#usage',
          },
          {
            condition: productState?.product?.ingredients,
            key: '#ingredients',
          },
          { condition: productState?.product?.resources, key: '#resources' },
        ]

        const firstAvailableTab = availableTabs.find(tab => tab.condition)

        if (isDefault == true) {
          return firstAvailableTab ? firstAvailableTab.key : '#details'
        } else {
          return firstAvailableTab ? firstAvailableTab.key : null
        }
      }
      let features = []
      let subtitle = ''
      try {
        if (productState?.product?.features) {
          ;({ features = [], subtitle = '' } =
            JSON.parse(productState?.product?.features)[0] || {})
        }
      } catch (e) {
        console.log('Data parse error::: ProductInfobar' + e)
      }

      const scrollToSection = id => {
        const element = document.getElementById(id.replace('#', ''))
        if (!element) return

        // Site-specific scroll logic
        if (isEquinoxMysite() || isEquinoxPOSite()) {
          const offset = scrollState?.calculateScrollOffset(
            isEquinoxMysite(),
            isEquinoxPOSite()
          )
          const elementRect = element.getBoundingClientRect()
          const absoluteElementTop = elementRect.top + window.pageYOffset
          const targetScrollPosition = absoluteElementTop - offset
          window.scrollTo({
            top: targetScrollPosition,
            behavior: 'smooth',
          })
        } else {
          // Default scroll logic — use same --header-height as sticky pill bar
          let tabBarHeight = 0
          const tabBar = document.querySelector('.product-details-title-bar')
          if (tabBar) {
            tabBarHeight = tabBar.offsetHeight
          }
          const stickyHeaderHeight = parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue(
              '--header-height'
            ) || '0'
          )
          const totalOffset = stickyHeaderHeight + tabBarHeight
          const elementRect = element.getBoundingClientRect()
          const absoluteElementTop = elementRect.top + window.pageYOffset
          const targetScrollPosition = absoluteElementTop - totalOffset
          window.scrollTo({
            top: targetScrollPosition,
            behavior: 'smooth',
          })
        }

        // Accessibility: Focus the heading or section after scroll
        const headingSelector = 'h1,h2,h3,h4,h5,h6,[data-section-heading]'
        const focusTarget = element.querySelector(headingSelector) || element

        const ioOptions = { threshold: 0.1, rootMargin: '0px 0px -20% 0px' }

        const doFocus = target => {
          try {
            if (!target.hasAttribute('tabindex'))
              target.setAttribute('tabindex', '-1')
            target.focus({ preventScroll: true })
          } catch (err) {
            target.focus()
          }
        }

        if (IS_BROWSER && 'IntersectionObserver' in window) {
          const obs = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
              if (entry.isIntersecting && entry.intersectionRatio > 0) {
                doFocus(focusTarget)
                observer.disconnect()
              }
            })
          }, ioOptions)
          obs.observe(element)

          setTimeout(() => {
            try {
              if (document.activeElement !== focusTarget) doFocus(focusTarget)
            } catch (e) {}
          }, 800)
        } else {
          setTimeout(() => doFocus(focusTarget), 350)
        }
      }

      const hasValidIngredients = raw => {
        try {
          if (!raw) return false

          const ingredients = typeof raw === 'string' ? JSON.parse(raw) : raw

          if (!Array.isArray(ingredients) || ingredients.length === 0)
            return false

          const item = ingredients[0]

          // Check if all fields are empty or only markdown/image
          const fieldsToCheck = [
            'ingredientDisclaimers',
            'keyIngredients',
            'otherIngredients',
            'allIngredients',
            'activeIngredients',
            'inactiveIngredients',
            'productName',
            'nutritionInformationImage',
          ]
          const allEmpty = fieldsToCheck.every(key => {
            const value = item[key]
            if (Array.isArray(value)) return value.length === 0
            if (typeof value === 'string') return value.trim() === ''
            return !value
          })
          // If markdown is present but all other fields are empty, treat as not valid
          if (
            allEmpty &&
            typeof item.markdown === 'string' &&
            item.markdown.trim().length > 0
          ) {
            return false
          }

          // Otherwise, check if any field is non-empty (excluding markdown)
          return Object.entries(item).some(([key, value]) => {
            if (key === 'markdown') return false
            if (Array.isArray(value)) return value.length > 0
            if (typeof value === 'string') return value.trim().length > 0
            return !!value
          })
        } catch (e) {
          console.error('Error parsing ingredients:', e)
          return false
        }
      }

      const renderNavItem = (condition, href, label) => {
        if (condition) {
          return (
            <Nav.Item key={href}>
              <Nav.Link
                onClick={e => {
                  e.preventDefault()
                  scrollToSection(href)
                }}
                className="custom-nav-link"
                href={href}>
                {label}
              </Nav.Link>
            </Nav.Item>
          )
        }
        return null
      }

      const safeParse = data => {
        try {
          return JSON.parse(data) || {}
        } catch (error) {
          return {}
        }
      }

      const isPbomProduct = productDeps.isPbomProduct(product)
      const { isStuck } = this.state
      return (
        <section
          className="express-checkout"
          data-testid="qa-product-details-wrapper">
          {!isProductEligible && (
            <div className="customer-modal">
              <Modal
                centered={true}
                data-testid="qa-attribute-pdp-modal"
                size={'md'}
                className={`modal-wrapper customertype-modal p-0`}
                show={this.showCustomerModal}
                onHide={this.handleClose}
                style={{
                  overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                  },
                }}
                dialogClassName="customertype-dialog">
                <Modal.Body>
                  <Modal.Header className={'border-bottom-0'} />
                  <div className="customertype-content">
                    <p className="paragraph-l pt-4 pb-2">
                      {i18nTranslate(
                        'pdp.eligible',
                        'You are not eligible to purchase this product',
                        {
                          nameSpace: 'ssr-resource',
                        }
                      )}
                    </p>
                    <Link to="/">
                      <Button
                        variant="primary"
                        data-testid="qa-attribute-home-button"
                        className="btn-addToCart border-0 w-100 text-uppercase rounded-0 d-flex justify-content-center align-items-center align-content-center">
                        {i18nTranslate('pdp.homePage', 'Go To Homepage', {
                          nameSpace: 'ssr-resource',
                        })}
                      </Button>
                    </Link>
                  </div>
                </Modal.Body>
              </Modal>
            </div>
          )}
          {/* {application.isMobile && this.renderTitle()} */}
          <div
            className={`pdp-page container-fluid py-3 ${enablePdpRedesign() ? 'pdp-redesign' : ''}`}>
            <Row noGutters className="position-relative">
              <Col sm={12} md={12} lg={6} className="mb-2 p-0 pr-lg-2 pr-xl-3">
                <ProductImageWithFavorites
                  product={product}
                  categoryId={categoryId}
                  location={location}
                  history={history}
                  isFromPDP={true}
                  isExpressPDP={true}
                />
              </Col>
              <Col sm={12} md={12} lg={6} className="pl-xl-3">
                <PDPContext.Provider
                  value={{
                    isPDP: true,
                  }}>
                  <ProductDetail
                    isExpressPDP={true}
                    handleSkuSelection={this.handleSkuSelection}
                    handleQuantityChange={this.handleQuantityChange}
                    handleQuantityChangePromotion={
                      productState?.handleQuantityChangePromotion
                    }
                    product={product}
                    selectSkuById={this.selectSkuById}
                    scanCount={scanCount}
                    productCount={productCount}
                    handleAddToBag={this.handleAddToBag}
                    categoryId={categoryId}
                    inventory={inventory}
                    subscribeAndSave={subscribeAndSave}
                    isSubscribeBtnDisabled={
                      nuskinSubscriptionContainer.displaySubscribeAndSavePrice
                    }
                    {...this.props}
                    renderBundlePriceAndButtons={
                      this.renderBundlePriceAndButtons
                    }
                  />
                </PDPContext.Provider>
                {(isPbomProduct || (!isBundle && !isCollection)) &&
                  (!enableNewPDPStyle ? (
                    <>
                      {product.shipping && this.enableLiveEvent !== 'true' && (
                        <ProductShipping product={product} />
                      )}
                      {product.refund && (
                        <ProductRefundPolicy product={product} />
                      )}
                      {!enablePdpRedesign() && (
                        <ProductDetailSection {...product} />
                      )}
                    </>
                  ) : (
                    <>
                      {!enablePdpRedesign() && (
                        <ProductDetailSection {...product} />
                      )}
                      {product.shipping && this.enableLiveEvent !== 'true' && (
                        <ProductShipping product={product} />
                      )}
                      {product.refund && (
                        <ProductRefundPolicy product={product} />
                      )}
                    </>
                  ))}
              </Col>
            </Row>
          </div>
          {product.features && !enablePdpRedesign() && (
            <ProductInfobar product={product} />
          )}
          {product?.crossSellProducts?.length > 0 && (
            <>
              {/* <FrequentlyBoughtTogether product={product?.crossSellProducts} /> */}
            </>
          )}

          <div className="bundle-products">
            <Container fluid>
              {!enableNewPDPStyle && isBundle && (
                <div className="mt-3">{this.renderBundleData(true)}</div>
              )}
              {isCollection && this.renderCollection()}
              {showCrossSellProducts() && (
                <CrossSellUpSell {...productResponse} />
              )}
              <ProductContext.Provider
                value={{
                  location: location,
                  history: history,
                  match: match,
                  name: product.name,
                }}></ProductContext.Provider>
            </Container>
          </div>
          <div
            className={`pdp-bottom-section-wrapper  ${enablePdpRedesign() ? 'pdp-redesign' : ''}`}>
            {getDefaultActiveKey(false) && (
              <div
                ref={this.barRef}
                className={
                  'product-details-title-bar' +
                  (isStuck ? ' stuck' : '') +
                  (isEquinoxMysite() ? ' equinox-mysite' : '') +
                  (isEquinoxPOSite() ? ' equinox-posite' : '')
                }>
                <div className="product-details-title-bar-div">
                  <div
                    className={`${enablePdpRedesign() ? 'pdp-redesign' : ''}`}>
                    <Nav
                      variant="pills"
                      defaultActiveKey={getDefaultActiveKey(true)}>
                      {renderNavItem(
                        (features?.length > 0 || subtitle) &&
                          enablePdpRedesign(),
                        '#why',
                        i18nTranslate('pdp.whyText', 'Why', {
                          nameSpace: this.nameSpace,
                        })
                      )}
                      {renderNavItem(
                        isProductDetailsAvailable(),
                        '#details',
                        i18nTranslate('pdp.detailsText', 'Details', {
                          nameSpace: this.nameSpace,
                        })
                      )}
                      {renderNavItem(
                        safeParse(
                          productState?.product?.benefits
                        )?.benefits?.trim().length > 0,
                        '#benefits',
                        i18nTranslate('pdp.benefits', 'Benefits', {
                          nameSpace: this.nameSpace,
                        })
                      )}
                      {renderNavItem(
                        safeParse(productState?.product?.usage).steps?.length >
                          0 ||
                          safeParse(productState?.product?.usage)
                            .recommendations?.length > 0 ||
                          safeParse(productState?.product?.usage).additionalText
                            ?.length > 0,
                        '#usage',
                        i18nTranslate('pdp.usage', 'Usage', {
                          nameSpace: this.nameSpace,
                        })
                      )}
                      {renderNavItem(
                        hasValidIngredients(
                          safeParse(productState?.product?.ingredients)
                        ),
                        '#ingredients',
                        i18nTranslate('pdp.ingredients', 'Ingredients', {
                          nameSpace: this.nameSpace,
                        })
                      )}
                      {renderNavItem(
                        safeParse(productState?.product?.results).image?.url ||
                          safeParse(productState?.product?.results).summary
                            ?.length > 0 ||
                          safeParse(productState?.product?.results).results
                            ?.length > 0,
                        '#results',
                        i18nTranslate('pdp.result', 'Result', {
                          nameSpace: this.nameSpace,
                        })
                      )}
                      {renderNavItem(
                        productState?.product?.resources,
                        '#resources',
                        i18nTranslate('pdp.resources', 'Resources', {
                          nameSpace: this.nameSpace,
                        })
                      )}
                    </Nav>
                  </div>
                </div>
              </div>
            )}
            {product.features && enablePdpRedesign() && (
              <ProductInfobar product={product} />
            )}
            {(product.productDetails || product.productDetailsDescription) && (
              <ProductDetailsDropdown product={product} />
            )}
            {/* Product similar carousel - crossSellProducts or from AWS recommended products */}
            {/* <RecommendedProducts product={product} /> */}
            {/* {product.crossSellProducts?.length > 0 && (
              <ProductSimilar product={product} />
            )} */}
            {product.benefits && (
              <ProductBenefitsandFeatures product={product} />
            )}
            {product.usage && this.isJsonObject(product.usage) && (
              <ProductHowtoUseit product={product} />
            )}
            {product.ingredients && <ProductIngredients product={product} />}
            <ProductSustainability product={product} />
            {product.results && <ProductProvenResults product={product} />}
            {product.resources && <ProductResources product={product} />}
            {product.faqs && <Productfaq product={product} />}
            {(product?.disclaimers || product?.disclaimerWarnings) && (
              <ProductDisclaimers product={product} />
            )}
            {/* {product.disclaimerWarnings && (
              <ProductDisclaimerWarnings product={product} />
            )} */}
          </div>

          {enablePdpRedesign() && (
            <RelatedProduct products={product?.crossSellProducts} />
          )}
        </section>
      )
    }

    return ''
  }
}

export { ExpressPDP }

export default ExpressPDP
